import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ChangeDetectorRef,
  AfterViewInit,
} from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { ISearchDropDown } from "./SearchDropdown";

@Component({
  selector: "app-search-dropdown",
  templateUrl: "./search-dropdown.component.html",
  styleUrls: ["./search-dropdown.component.css"],
})
export class SearchDropdownComponent
  implements OnInit, OnChanges, AfterViewInit
{
  dropdownInput: string = "";
  @Input() SearchData: ISearchDropDown;
  @Input() disabled: boolean = false;

  dropdownVisible: boolean = false;
  dropdownDiv: string = `div${Date.now()}-${Math.random()
    .toString(36)
    .substr(2, 9)}`;
  dropdown_name: string = `dropdown_name${Date.now()}-${Math.random()
    .toString(36)
    .substr(2, 9)}`;
  filteredDropdown = [];
  selectedItem = null;
  selectedAccId: any = "0";
  @Output() notify: EventEmitter<any> = new EventEmitter<any>();
  @Output() refresh: EventEmitter<void> = new EventEmitter<void>();

  constructor(private sanitizer: DomSanitizer, private cdr: ChangeDetectorRef) {
    this.initialData();
  }

  initialData(): void {
    this.SearchData = {
      DataList: [],
      SelectedText: "",
      SelectedId: "",
      DropdownTitle: "",
      EnabledOrDisabled: false,
      PatchId: "0",
      isRequried: false,
      placeholder: "",
    };
  }

  ngOnInit(): void {
    this.cdr.detectChanges();
  }

  ngAfterViewInit(): void {
    this.cdr.detectChanges();
  }

  ngOnChanges(changes: SimpleChanges) {
    let dataListChanged = false;
    let patchIdChanged = false;

    if (changes["SearchData"]) {
      const currentDataList =
        changes["SearchData"].currentValue?.DataList || [];
      const previousDataList =
        changes["SearchData"].previousValue?.DataList || [];

      if (currentDataList !== previousDataList) {
        this.filteredDropdown = currentDataList || [];
        dataListChanged = true;

        // Only clear input if no patchId
        if (!this.SearchData?.PatchId || this.SearchData?.PatchId === "0") {
          this.dropdownInput = "";
        }
      }

      const currentPatchId = changes["SearchData"].currentValue?.PatchId || "0";
      const previousPatchId =
        changes["SearchData"].previousValue?.PatchId || "0";

      if (currentPatchId !== previousPatchId) {
        this.selectedAccId = +currentPatchId;
        patchIdChanged = true;
      }
    }

    // If anything relevant changed, update selected item
    if (dataListChanged || patchIdChanged) {
      if (this.selectedAccId > 0 && this.SearchData?.DataList?.length > 0) {
        this.updateSelectedItem();
      }
    }
  }

  updateSelectedItem(): void {
    setTimeout(() => {
      if (this.selectedAccId > 0 && this.SearchData?.DataList?.length > 0) {
        const updatedata = this.SearchData.DataList.find(
          (e) => +e[this.SearchData.SelectedId] === +this.selectedAccId
        );

        if (updatedata) {
          this.selectItem(updatedata);
        } else {
          this.dropdownInput = "";
          this.selectedItem = null;
          this.notifyParent();
        }
      }
    }, 100);
  }

  @HostListener("document:click", ["$event"])
  onClick(event: Event) {
    const target = event.target as HTMLElement;

    if (
      !target.closest(`#${this.dropdown_name}`) &&
      !target.closest(`#${this.dropdownDiv}`)
    ) {
      this.dropdownVisible = false;
    }
  }

  showDropdown() {
    this.dropdownVisible = true;

    // Recalculate filteredDropdown on every click
    if (this.SearchData?.DataList?.length > 0) {
      const input = this.dropdownInput?.toLowerCase() || "";
      this.filteredDropdown = this.SearchData.DataList.filter((e) =>
        e[this.SearchData.SelectedText]?.toLowerCase().includes(input)
      );
    }
    this.refresh.emit();
  }

  filterDropDown() {
    const input = this.dropdownInput?.toLowerCase() || "";
    const dataList = this.SearchData?.DataList || [];

    // If input is empty, show full list and reset selection
    if (!input) {
      this.filteredDropdown = dataList;
      this.dropdownVisible = false;
      this.selectedItem = null;
      this.notifyParent();
      return;
    }

    // Filter list based on input
    this.filteredDropdown = dataList.filter((e) =>
      e[this.SearchData.SelectedText]?.toLowerCase().includes(input)
    );

    this.dropdownVisible = this.filteredDropdown.length > 0;

    // If typed value no longer matches the selected item, clear it
    if (
      this.selectedItem &&
      this.dropdownInput !== this.selectedItem[this.SearchData.SelectedText]
    ) {
      this.selectedItem = null;
      this.notifyParent();
    }
  }

  selectItem(item: any) {
    this.dropdownInput = item[this.SearchData.SelectedText];
    this.selectedItem = item;
    this.filteredDropdown = []; // clear the filtered list
    this.notifyParent();
    this.dropdownVisible = false;
  }

  highlightText(text: string, input: string): SafeHtml {
    const index = text?.toLowerCase().indexOf(input?.toLowerCase());
    if (index !== -1) {
      const highlightedText =
        text?.substring(0, index) +
        '<span style="color:blue; font-weight:bold">' +
        text?.substring(index, index + input.length) +
        "</span>" +
        text?.substring(index + input.length);
      return this.sanitizer.bypassSecurityTrustHtml(highlightedText);
    }
    return this.sanitizer.bypassSecurityTrustHtml(text);
  }

  notifyParent() {
    this.notify?.emit({ ...this.selectedItem });
  }
}
